import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, Validators } from '@angular/forms'
import { TypedFormGroup } from '@feature/forms/form-model';;
import { SnackBarService } from '@feature/snack-bar/snack-bar.service';
import { TranslateService } from '@ngx-translate/core';
import { FileSizeError } from '@shared/file-picker/file-picker.directive';
import { FileSizePipe } from '@shared/pipes/file-size/file-size.pipe';

@Component({
    selector: 'wai-dataroom-uploader',
    templateUrl: './uploader.component.html',
    styleUrls: ['./uploader.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class UploaderComponent {
  public asTypedFormGroup = (x: unknown): TypedFormGroup<any> => x as TypedFormGroup<any>;

  public file: FormControl;
  @Input() public withLabel = true;
  @Output() public fileSelected: EventEmitter<File> = new EventEmitter();

  constructor(private snackbar: SnackBarService, private translate: TranslateService) {
    this.file = new FormControl([null, [Validators.required]]);
  }

  public onSubmit(file: File): void {
    this.fileSelected.emit(file);
  }

  public onFileSizeError(error: FileSizeError): void {
    this.snackbar.error('INTL_FORM_ERROR_MAX_CONTENT_SIZE', {
      maxSize: new FileSizePipe(this.translate.currentLang).transform(error.maxSize),
      actualSize: new FileSizePipe(this.translate.currentLang).transform(error.file.size),
    });
  }
}
